import React, { useEffect, useState } from "react";
import { Textarea } from "../atoms/Input";
import styled from "styled-components";
import { Radio, RadioWrap } from "../atoms/Radio";

const ReviewItem = ({ children, ...props }) => {
    const { data, idx, stateValue } = props;

    return (
        <CustomReviewItem className="review-card">
            <ReviewQuestion data={data} idx={idx}></ReviewQuestion>
            <ReviewAnswer data={data} stateValue={stateValue}></ReviewAnswer>
        </CustomReviewItem>
    );
};

const CustomReviewItem = styled.div`
`;

const ReviewQuestion = ({ children, ...props }) => {
    const { data, idx } = props;

    return (
        <>
            {data && (
                <CustomReviewQuestion>
                    Q. {data.title}
                    <div className="desc">{data.description}</div>
                </CustomReviewQuestion>
            )}
        </>
    );
};

const CustomReviewQuestion = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3em;

    .desc {
        font-size: 15px;
        font-weight: 500;
        line-height: 1.5em;
        color: var(--gray3-color);
    }
`;

const ReviewAnswer = ({ children, ...props }) => {
    const { data, stateValue } = props;

    return (
        <>
            {data && data.type === "0" && <ReviewAnswerMultiple idx={data.idx} options={data.option} stateValue={stateValue} />}
            <ReviewAnswerShort data={data} idx={data.idx} stateValue={stateValue} />
        </>
    );
};

const ReviewAnswerShort = ({ ...props }) => {
    const { data, idx, stateValue } = props;
    const [answerIdx, setAnswerIdx] = useState(0);

    useEffect(() => {
        if (stateValue[0] && idx) {
            stateValue[0].map((el, elIdx) => {
                if (el.question_idx === idx) {
                    setAnswerIdx(elIdx);
                }
            });
        }
    }, [stateValue, idx]);

    const reviewAnswerOnchangeHandler = (e) => {
        let tmp = [...stateValue[0]];
        tmp[answerIdx].answer_text = e.target.value;

        stateValue[1](tmp);
    };

    return (
        <>
            {data.is_comment_enabled === "1" && (
                <Textarea 
                    name={"answer_" + idx} 
                    value={stateValue[0][answerIdx]?.answer_text} 
                    stateValue={stateValue} 
                    onChange={(e) => reviewAnswerOnchangeHandler(e)} 
                    placeholder={`코멘트를 입력해주세요. ${data.is_subjective_answer_required === "0" || data.type === "0" ? "(선택)" : ""}`} 
                    />
            )}
        </>
    );
};

const ReviewAnswerMultiple = ({ ...props }) => {
    const { idx, options, stateValue } = props;
    const [val, setVal] = useState("");
    const [answerIdx, setAnswerIdx] = useState(0);

    useEffect(() => {
        if (stateValue[0] && idx) {
            stateValue[0].map((el, elIdx) => {
                if (el.question_idx === idx) {
                    setAnswerIdx(elIdx);
                    setVal(el.option_idx);
                }
            });
        }
    }, [stateValue, idx]);

    const reviewAnswerOnchangeHandler = (e) => {
        let tmp = [...stateValue[0]];
        tmp[answerIdx].option_idx = e.target.value;

        stateValue[1](tmp);
    };

    return (
        <>
            <RadioWrap col name={"answer_" + idx} stateValue={stateValue} onChange={(e) => reviewAnswerOnchangeHandler(e)}>
                {options.map((option) => {
                    return (
                        <Radio key={option.text} value={option.idx} isChecked={option.idx === val ? true : false}>
                            <OptionText>{option.text}</OptionText>
                        </Radio>
                    );
                })}
            </RadioWrap>
        </>
    );
};

const OptionText = styled.div`
    color: var(--dark-color);
    font-size: 16px;
    line-height: 1.5em;
    letter-spacing: -0.03em;
`

export { ReviewItem, ReviewQuestion, ReviewAnswer };